module.exports = __webpack_public_path__ + "img/placeholder-port.59631134.svg";